/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { scopes } from './scopes'

export const environment = {
  production: true,
  baseUrl: 'https://profile.porsche.com',
  environmentUrlAddition: '/myprofile',
  mock: {
    accessKey: null,
  },
  publicApi: {
    baseUrl: 'https://api.profile.porsche.com/user/v1',
    localisation: 'https://localise.profile.porsche.com',
    signup: 'https://api.signup.porsche.com/',
  },
  mfaApi: {
    baseUrl: 'https://api.access.porsche.com',
  },
  logger: {
    showLogs: false,
    showWarnings: false,
  },
  featureToggles: {
    restrictGlobalUIChanges: true,
    enabled: ['ALLOW_OWNER_NAME_CHANGE'],
  },
  oauth: {
    clientId: 'K2SaA3ojBmgbP95WtBYUfZwis9zM2bWB',
    domain: 'identity.porsche.com',
    authorizationParams: {
      // eslint-disable-next-line camelcase
      redirect_uri: 'https://profile.porsche.com/myprofile/auth/callback',
      audience: 'https://api.porsche.com',
      scope: scopes.join(' '),
    },
    useRefreshTokens: false,
    httpInterceptor: {
      allowedList: [
        'https://api.profile.porsche.com/user/v1*',
        'https://api.access.porsche.com/api/v2/account/mfa/status',
        'https://api.signup.porsche.com/registration/v1*',
      ],
    },
  },
  payment: {
    apiKey: 'K2SaA3ojBmgbP95WtBYUfZwis9zM2bWB',
    view: 'payment-data-management',
    scriptUrl: 'https://pay.porsche.com/widget/v3.3/widget-angular.js',
  },
  googleTagManagerV2: {
    enable: true,
    skipInitialPageView: true,
    data: {
      context: {
        applicationId: 'myporsche_idprofile',
        environment: 'P',
      },
    },
    containerId: 'GTM-W2NKNJZ',
  },
  externalUrls: {
    connectStore: 'https://connect-store.porsche.com',
    access: 'https://security.porsche.com/auth',
    orders: 'https://myhistory.porsche.com',
  },
  fullstory: {
    devMode: false,
    orgId: 'o-7SGZ-eu1',
  },
  cookieConsent: {
    enable: true,
    usc: {
      useItpBridge: true,
      enableForLocalhost: false,
    },
  },
  countryLanguageFallback: {
    country: 'en',
    language: 'en',
    locale: 'en_GB',
  },
}
